export default {
  title: 'Gestionar cuenta',
  buttons: {
    save: 'Guardar',
    delete: 'Eliminar',
  },
};
